import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '../../css';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { useLocaleContext } from '../../../context/LocaleContext';

import {
  Backdrop,
  Content,
  Button,
  Heading,
  FixedContent,
  ChildrenContent
} from './css';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const ModalCustom = ({
  open,
  setOpen,
  header,
  children,
  customStyles,
  hideCloseButton
}) => {
  // const localizedStrings = useLocalizedStringsContext();
  const local = useLocaleContext();

  const {
    MODAL: { BUTTON_CLOSE }
  } = local === 'en-US' ? EN : FR;

  return (
    open && (
      <Backdrop>
        <Content customStyles={customStyles}>
          <FixedContent
            style={{
              background: 'rgb(75, 40, 109)',
              position: 'sticky',
              top:"0px",
              width: '100%',
              zIndex: '999',
            }}
          >
            <Box width={80}>
              <Heading>{header}</Heading>
            </Box>
            <Box
              width={50}
              display="flex"
              justifyContent="flex-end"
              flexDirection="row"
            >
              {!hideCloseButton && (
                <Button
                  className="buttonclose"
                  style={{
                    color: 'white',
                    borderRadius: '50%',
                    border: ' 1px solid white',
                    height: '27px',
                    width: '27px',
                    fontSize: '15px',
                    background: 'rgb(75, 40, 109)',
                    marginTop: '4px'
                  }}
                  popupHeader
                  onClick={() => setOpen()}
                >
                  {BUTTON_CLOSE}
                </Button>
              )}
            </Box>
          </FixedContent>
          <ChildrenContent>{children}</ChildrenContent>
        </Content>
      </Backdrop>
    )
  );
};

ModalCustom.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  customStyles: PropTypes.objectOf(PropTypes.object)
};

ModalCustom.defaultProps = {
  open: false,
  customStyles: null
};
export default ModalCustom;
